import React, {
  Component
} from "react";
import { withRouter } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from "@material-ui/core/styles";
import qs from "query-string";
import {
  QUICK_LOGIN
} from "config/url";
import { withCurl } from "zh-common-modules";
import { setStorage } from "utils";

const styles = {
  root : {
    height  : "100%",
    width   : "100%",
    position  : "relative"
  },
  progress : {
    position  : "absolute",
    top       : "50%",
    left      : "50%",
    transform : "translate(-50%, -50%)"
  }
}

class QuickSignIn extends Component {
  handleRoute = (target) => {
    this.props.history.replace(target);
  }

  componentWillMount = () => {
    const { curl, location } = this.props;
    const params = qs.parse(location.search);
    curl.get(QUICK_LOGIN, {
      code : params.code
    }).then(res => {
      setStorage(res);
      let url = "/";
      if(params.reportid){
        url = `/weekly-report-detail?id=${params.reportid}`
      }
      this.handleRoute(url);
    }).catch(e => {
      this.handleRoute("/sign-in");
    })
  }

  render(){
    const {
      classes
    } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.progress}>
          <CircularProgress/>
        </div>
      </div>
    )
  }
}

export default withCurl(false, false)(withStyles(styles)(withRouter(QuickSignIn)));